import { IItem, IItemVariant, IItemVariantOptionMap } from '@rediredi/types'

export const stringToHTML = (string: string) => string.replace(/\n/gim, '<br />')

export const getVariantByOptions = (variants: IItemVariant[], options: IItemVariantOptionMap[]) => {
  if (!options.length) return

  return variants.find((variant) => {
    if (!variant.optionMapping) return false
    return variant.optionMapping.every((option, i) => {
      if (!options[i]) return false
      return option.name === options[i].name && option.value === options[i].value
    })
  })
}

export const getItemVariants = (item: IItem) => {
  const variants = []
  if (item?.baseVariant) variants.push(item?.baseVariant)
  variants.push(...(item?.additionalVariants || []))
  return variants.filter((variant) => !variant.archived)
}

export const getCoverVariant = (item: IItem | IStorefrontItem, withStock = false) => {
  const variants = getItemVariants(item).filter((variant) =>
    withStock ? (variant.quantityTotal || 0) > 0 : true,
  )
  return variants.find((variant) => variant.position === 1) || item.baseVariant
}

export const getCoverVariantPictures = (item: IItem) => {
  if (item.options?.length) {
    const coverVariant = getCoverVariant(item, true)

    if (coverVariant?.pictures?.length) return coverVariant.pictures
  }
  if (item.pictures?.length) {
    return item.pictures
  }
  return []
}
